// prettier-ignore
export let ABI = [{
        "constant": true,
        "inputs": [{
            "name": "_n",
            "type": "string"
        }],
        "name": "getFeature",
        "outputs": [{
            "name": "_addr",
            "type": "address"
        }, {
            "name": "_ver",
            "type": "string"
        }],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    }
];
